import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=1570aa60"
import script from "./DashboardLayout.vue?vue&type=script&lang=ts"
export * from "./DashboardLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports